import { ApiResponseType } from '@/api/type/commonTypes';
import { api } from '../axiosInstance';
import { GetPartnerDashboardResponse } from '../type/types';

// 파트너 > 대시보드
export const getPartnerDashboard = async () => {
  const res = await api.get<ApiResponseType<GetPartnerDashboardResponse>>(
    `/api/web/partners/dashboard`
  );
  return res.data;
};
